// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2NNHC","productName":"Table_productName__anKNN"};